import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-copyright">
            © 2024 Swapwise HK
          </div>
          <div className="footer-links">
            <Link to="#" className="footer-link">About Us</Link>
            <Link to="#" className="footer-link">Terms</Link>
            <Link to="#" className="footer-link">Privacy</Link>
            <Link to="#" className="footer-link">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 